import { render, staticRenderFns } from "./OsSheet.vue?vue&type=template&id=40f12fb9&scoped=true"
import script from "./OsSheet.vue?vue&type=script&lang=ts"
export * from "./OsSheet.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f12fb9",
  null
  
)

export default component.exports